import { useState, useEffect } from "react";
import { HiOutlineUsers, HiOutlineGlobe, HiOutlineChartBar } from "react-icons/hi";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import banner5 from "../assets/banner5.jpg";

const impactData = [
  { img: banner1, metric: "01", label: "Privately Owned Company", icon: <HiOutlineUsers size={48} /> },
  { img: banner2, metric: "05", label: "Core Product Lines", icon: <HiOutlineChartBar size={48} /> },
  { img: banner3, metric: "24/7", label: "Guest and Support Services", icon: <HiOutlineGlobe size={48} /> },
  { img: banner4, metric: "TZ", label: "Tanzania Hospitality Focus", icon: <HiOutlineChartBar size={48} /> },
  { img: banner5, metric: "100%", label: "Customer-Centered Service", icon: <HiOutlineGlobe size={48} /> }
];

export default function HomeBanner2() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive(p => (p + 1) % impactData.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@300;400;500;600;700;800&display=swap');
        :root { --sunflower-amber: #BC9132; --text-navy: #012243; --text-slate: #475569; --bg-light: #F8FAFC; --border-subtle: #E2E8F0; --font-corporate: 'Libre Franklin', sans-serif; }
        .impact-viewport { position: relative; width: 100%; min-height: 85vh; display: flex; align-items: center; justify-content: center; font-family: var(--font-corporate); background: var(--text-navy); overflow: hidden; }
        .impact-bg { position: absolute; inset: 0; background-size: cover; background-position: center; opacity: 0; transition: opacity 1.5s ease-in-out; }
        .impact-bg.active { opacity: 0.35; }
        .impact-overlay { position: absolute; inset: 0; background: linear-gradient(135deg, rgba(15,23,42,0.95) 0%, rgba(15,23,42,0.6) 100%); }
        .impact-content { position: relative; z-index: 2; text-align: center; color: #fff; max-width: 900px; padding: 0 24px; }
        .impact-icon { color: var(--sunflower-amber); margin-bottom: 24px; opacity: 0.9; }
        .impact-metric { font-size: clamp(3.5rem, 10vw, 7rem); font-weight: 800; color: var(--sunflower-amber); margin-bottom: 16px; letter-spacing: -0.04em; line-height: 1; transition: all 0.5s ease; }
        .impact-label { font-size: clamp(1rem, 2vw, 1.35rem); font-weight: 500; color: #E2E8F0; text-transform: uppercase; letter-spacing: 0.15em; transition: all 0.5s ease; }
        .impact-dots { display: flex; gap: 12px; justify-content: center; margin-top: 60px; }
        .impact-dot { width: 12px; height: 12px; border-radius: 50%; background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); cursor: pointer; transition: all 0.3s ease; }
        .impact-dot.active { background: var(--sunflower-amber); border-color: var(--sunflower-amber); transform: scale(1.3); box-shadow: 0 0 15px rgba(188, 145, 50, 0.5); }
      `}</style>

      <section className="impact-viewport">
        {impactData.map((item, idx) => (
          <div key={idx} className={`impact-bg ${idx === active ? 'active' : ''}`} style={{ backgroundImage: `url(${item.img})` }} />
        ))}
        <div className="impact-overlay" />
        
        <div className="impact-content">
          <div className="impact-icon">{impactData[active].icon}</div>
          <h2 className="impact-metric">{impactData[active].metric}</h2>
          <p className="impact-label">{impactData[active].label}</p>
          
          <div className="impact-dots">
            {impactData.map((_, idx) => (
              <div key={idx} className={`impact-dot ${idx === active ? 'active' : ''}`} onClick={() => setActive(idx)} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
